import useTranslation from 'hooks/useTranslation'
import Popup from 'components/popups/Popup'
import React from 'react'

interface Option {
  id: string
  name: string
  description: string
  order?: number
}

interface SelectGateModalProps {
  isGate?: boolean
  options: Option[]
  callback: (placeId: string) => void
}

const SelectGateModal: React.FC<SelectGateModalProps> = ({ isGate = true, options, callback }) => {
  const { t } = useTranslation('entrance')
  return (
    <Popup>
      <div className='selectGate__popup'>
        <div className='popup__title'>
          <div>{t(isGate ? 'openGate' : 'openGateway')}</div>
          <div>{t(isGate ? 'whichGateWouldYouLikeToOpen' : 'whichGatewayWouldYouLikeToOpen')}</div>
        </div>
        <div className='selectGate__options'>
          {options
            .sort((a, b) => (typeof a.order === 'number' && typeof b.order === 'number') ? a.order - b.order : 0)
            .map((option) => <div
              key={option.id}
              className='selectGate__option'
              onClick={() => {
                callback(option.id)
              }}>
              <div className='group'>
                <div />
                <div className='selectGate__option__arrow center'>
                  <i className='icon icon--arrow-right' />
                </div>
              </div>
              <div className='selectGate__option__title --secFont'>{option.name}</div>
              <div className='selectGate__option__desc'>{option.description}</div>
            </div>
            )}
        </div>
      </div>
    </Popup>
  )
}

export default SelectGateModal